import React, { useEffect, useRef } from "react";
import BouncingDiv from "../BouncingDiv";
import AfterYou from "../assets/videos/after-you.mp4";
import YMLogo from "../assets/YMLogo";

export default function AfterYouPage({ setAverageColor, setOppositeColor }) {
  const canvasRef = useRef();
  const videoRef = useRef();

  return (
    <div
      id="bounce-container"
      className="relative flex h-[100dvh] min-w-[100dvw] flex-1 shrink-0  snap-center items-center justify-center bg-amber-100"
    >
      <canvas ref={canvasRef} className=" hidden h-[10vh] w-full" />
      <video
        autoPlay
        id="video-background"
        ref={videoRef}
        muted
        loop
        playsInline
        className="absolute flex h-full w-full object-cover "
        onLoad={() => {
          console.log("loaded");
        }}
      >
        <source src={AfterYou} type="video/mp4" />
      </video>
      <div className="font-kings absolute top-1/2 z-[80] flex h-[30vw] w-[80%] -translate-y-1/2 items-center rounded-md  text-[10vw] font-[800] mix-blend-difference ">
        <div
          className="flex min-h-[100%] min-w-[100%] animate-fade cursor-pointer rounded-md bg-[#53e639]"
          onClick={() => {
            window.open(
              "https://www.youtube.com/watch?v=BsEOtQTElTw",
              "_blank",
            );
          }}
        />
        <p className="absolute w-full pl-[10px] text-center text-[10vw] tracking-[15px] text-white opacity-[100%] mix-blend-plus-lighter">
          After You
        </p>
        <p className="absolute bottom-[2%] right-[2%] z-[0] text-[4vw] tracking-[2px] text-white opacity-[100%]">
          Gurg x JuuJaan
        </p>
      </div>
      <BouncingDiv size={50}>
        <YMLogo />
      </BouncingDiv>
    </div>
  );
}
